import React from "react"
import playStoreIcon from "../../assets/icons/play-store.svg"
import appStoreIcon from "../../assets/icons/app-store.svg"

import styles from "./AppStoreButton.module.scss"

type AppStoreButtonProps = {
  isAppleStore: boolean
}

const appStoreUrl = "https://itunes.apple.com/gb/app/agile-coaching-cards/id1447386465?mt=8"
const playStoreUrl = "https://play.google.com/store/apps/details?id=com.inspectandadapt.agilecards"

const AppStoreButton: React.FC<AppStoreButtonProps> = ({ isAppleStore }) => {
  const url = isAppleStore ? appStoreUrl : playStoreUrl
  return (
    <img
      className={styles.button}
      role="button"
      title="View in App Store"
      src={isAppleStore ? appStoreIcon : playStoreIcon}
      alt={isAppleStore ? "Apple App Store" : "Google Play Store"}
      onClick={() => open(url, "_blank")}
    />
  )
}

export default AppStoreButton
